module.exports = __webpack_public_path__ + "static/bg-aula-88d7a1f5fb27adb874a4d33e63677ecb.png";